import { ModuleForm, ModuleHeader, ModuleItems } from "../components/index";
import { PageContextInvoiceViewProvider } from "../context/invoice-view-provider";

export default function LayoutPageInvoiceView() {
  return (
    <>
      <PageContextInvoiceViewProvider>
        <ModuleHeader />
        <ModuleForm />
        <ModuleItems />
      </PageContextInvoiceViewProvider>
    </>
  );
}
